import axios from "axios";
import { GuestCreateAppType } from "../../common/types/GuestCreateAppType";

export const createApplicationGuest = (
  customerDetails: GuestCreateAppType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer`,
      {
        params: {
          context: {},
          data: customerDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
